export default "__VITE_ASSET__Ve1xlV0w__"